import { lazy, Suspense, useState } from "react";
import Modal from "../../../components/Modal/modal";
import "./ribbon.css";
import { TopBannerData } from "../types";
import DOMPurify from "dompurify";

// Lazy: the banner popup (incl. CTAButtons -> PrizeTicketSelector) only loads on ribbon click.
const TopBannerPopup = lazy(() => import("./topBannerPopup"));

type RibbonProps = {
  topBannerData: TopBannerData;
};

const Ribbon = ({ topBannerData }: RibbonProps) => {
  const [isRibbonModelPopupVisible, setIsRibbonModelPopupVisible] = useState(false);

  const ribbonContent = topBannerData?.TopBannerContent.replace(
    "{{click_behaviour}}",
    topBannerData.TopBannerClickBehaviour
  );

  return (
    <>
      <div
        onClick={() => topBannerData.TopBannerClickBehaviour !== "unclickable" && setIsRibbonModelPopupVisible(true)}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(ribbonContent) }}
      />
      <Modal
        isOpen={isRibbonModelPopupVisible}
        isCloseButtonRequired={false}
        title=""
        modalClassNames="rounded-2xl !p-0 z-[1002] relative xs:w-[95%]"
        body={
          // Only construct (and thus load) the popup once it is actually opened
          isRibbonModelPopupVisible ? (
            <Suspense fallback={null}>
              <TopBannerPopup
                prizeId={topBannerData?.PrizeId}
                competitionId={topBannerData?.CompetitionId}
                ctaButtonText={topBannerData?.CtaButtonText}
                ctaButtonLink={topBannerData?.CtaButtonLink}
                popupHtml={topBannerData?.PopupHtml}
                openModal={setIsRibbonModelPopupVisible}
              />
            </Suspense>
          ) : null
        }
      />
    </>
  );
};

export default Ribbon;
